import { render, staticRenderFns } from "./NewsLabel.vue?vue&type=template&id=f84f80a2&"
import script from "./NewsLabel.vue?vue&type=script&lang=ts&"
export * from "./NewsLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports